import { useEffect } from 'react';

import { CARD_IDS } from '@/components/emotion-detector/constants';

interface UseAutoRevealSelectionProps {
	needsConfirm: boolean;
	emotion: string | null;
	captureCardVisible: boolean;
	addVisibleCardAndScroll: (card: string) => void;
}

/**
 * Automatically reveals the selection card when emotion is detected
 */
export function useAutoRevealSelection({
	needsConfirm,
	emotion,
	captureCardVisible,
	addVisibleCardAndScroll,
}: UseAutoRevealSelectionProps) {
	useEffect(() => {
		if ((needsConfirm || emotion) && captureCardVisible) {
			addVisibleCardAndScroll(CARD_IDS.SELECTION);
		}
	}, [needsConfirm, emotion, addVisibleCardAndScroll, captureCardVisible]);
}
